module.exports = __webpack_public_path__ + "img/AW.ab68008c.svg";